import React from 'react';
import { Card, Alert, ListGroup, Badge, Row, Col } from 'react-bootstrap';

const RiberaStep6 = ({ formData, onSubmit }) => {
    const renderFileInfo = (file, label) => {
        if (!file || (Array.isArray(file) && file.length === 0)) {
            return (
                <ListGroup.Item className="d-flex justify-content-between align-items-center">
                    <span>{label}</span>
                    <Badge bg="secondary">No cargado</Badge>
                </ListGroup.Item>
            );
        }

        if (Array.isArray(file)) {
            return (
                <ListGroup.Item className="d-flex justify-content-between align-items-center">
                    <span>{label}</span>
                    <Badge bg="success">{file.length} archivo(s)</Badge>
                </ListGroup.Item>
            );
        }

        return (
            <ListGroup.Item className="d-flex justify-content-between align-items-center">
                <span>{label}</span>
                <Badge bg="success">✓ Cargado</Badge>
            </ListGroup.Item>
        );
    };

    const renderFieldInfo = (value, label) => {
        return (
            <ListGroup.Item className="d-flex justify-content-between align-items-center">
                <span>{label}</span>
                <span className="text-muted">
                    {value || <Badge bg="secondary">No ingresado</Badge>}
                </span>
            </ListGroup.Item>
        );
    };

    return (
        <Card className="shadow-sm">
            <Card.Header className="bg-success text-white">
                <h5 className="mb-0">Paso 6: Revisión Final y Envío</h5>
            </Card.Header>
            <Card.Body>
                <Alert variant="info" className="mb-4">
                    <strong>Revisión de la Presentación:</strong> Verifique que todos los datos sean correctos.
                </Alert>

                <h6 className="text-primary mb-3">Datos del Profesional</h6>
                <ListGroup className="mb-4">
                    {renderFieldInfo(formData.nombreApellido, 'Nombre y Apellido')}
                    {renderFieldInfo(formData.matricula, 'Matrícula')}
                    {renderFieldInfo(formData.colegioProfesional, 'Colegio Profesional')}
                    {renderFieldInfo(formData.email, 'Email')}
                    {renderFieldInfo(formData.telefono, 'Teléfono')}
                </ListGroup>

                <h6 className="text-primary mb-3">Documentación Administrativa</h6>
                <ListGroup className="mb-4">
                    {renderFileInfo(formData.notaPedidoDeslinde, 'Nota de Pedido de Deslinde')}
                    <ListGroup.Item className="d-flex justify-content-between align-items-center">
                        <span>Prescripción Adquisitiva</span>
                        <Badge bg={formData.prescripcionAdquisitiva ? 'primary' : 'secondary'}>
                            {formData.prescripcionAdquisitiva ? 'Sí' : 'No'}
                        </Badge>
                    </ListGroup.Item>
                    {!formData.prescripcionAdquisitiva &&
                        renderFileInfo(formData.informeRegistro, 'Informe de Registro Inmobiliario')}
                    {renderFileInfo(formData.notaAutorizacion, 'Nota de Autorización')}
                </ListGroup>

                <h6 className="text-primary mb-3">Documentación Técnica</h6>
                <ListGroup className="mb-4">
                    {renderFileInfo(formData.planoDXF, 'Plano DXF')}
                    {renderFileInfo(formData.planoPDF, 'Plano PDF Firmado')}
                    {renderFileInfo(formData.memoriaDescriptiva, 'Memoria Descriptiva')}
                    {renderFieldInfo(formData.emailObservaciones, 'Email para Observaciones')}
                </ListGroup>

                <h6 className="text-primary mb-3">Información de Campo</h6>
                <ListGroup className="mb-4">
                    {renderFileInfo(formData.imagenesCauce, 'Imágenes del Cauce')}
                    {renderFileInfo(formData.imagenesBarranca, 'Imágenes de la Barranca')}
                    {renderFieldInfo(formData.alturaBarranca ? `${formData.alturaBarranca} m` : '', 'Altura de Barranca')}
                    {renderFieldInfo(formData.distanciaBarrancaMensura ? `${formData.distanciaBarrancaMensura} m` : '', 'Distancia Barranca-Mensura')}
                    <ListGroup.Item className="d-flex justify-content-between align-items-center">
                        <span>Ubicación Geográfica</span>
                        {formData.ubicacionGeografica ? (
                            <Badge bg="success">
                                {formData.ubicacionGeografica.lat}, {formData.ubicacionGeografica.lng}
                            </Badge>
                        ) : (
                            <Badge bg="secondary">No especificada</Badge>
                        )}
                    </ListGroup.Item>
                </ListGroup>

                <h6 className="text-primary mb-3">Comprobante de Pago</h6>
                <ListGroup className="mb-4">
                    {renderFileInfo(formData.comprobantePago, 'Formulario F924')}
                </ListGroup>

                <Alert variant="warning" className="mt-4">
                    <h6>⚠️ Checklist Informativo</h6>
                    <Row>
                        <Col md={6}>
                            <ul className="mb-0">
                                <li className={formData.nombreApellido ? 'text-success' : 'text-muted'}>
                                    Datos del profesional completos
                                </li>
                                <li className={formData.notaPedidoDeslinde ? 'text-success' : 'text-muted'}>
                                    Documentación administrativa
                                </li>
                                <li className={formData.planoDXF && formData.planoPDF ? 'text-success' : 'text-muted'}>
                                    Planos georreferenciados
                                </li>
                            </ul>
                        </Col>
                        <Col md={6}>
                            <ul className="mb-0">
                                <li className={formData.memoriaDescriptiva ? 'text-success' : 'text-muted'}>
                                    Memoria descriptiva
                                </li>
                                <li className={formData.imagenesCauce || formData.imagenesBarranca ? 'text-success' : 'text-muted'}>
                                    Documentación fotográfica
                                </li>
                                <li className={formData.comprobantePago ? 'text-success' : 'text-muted'}>
                                    Comprobante de pago
                                </li>
                            </ul>
                        </Col>
                    </Row>
                    <p className="mt-3 mb-0">
                        <small>
                            <strong>Nota:</strong> Este checklist es informativo. En la versión productiva,
                            todos los ítems deberán estar completados para proceder con el envío.
                        </small>
                    </p>
                </Alert>

            </Card.Body>
        </Card>
    );
};

export default RiberaStep6;
